export const COST_LABEL = (c, zh) => ({
  material: zh ? "材料" : "Material", labor: zh ? "人工" : "Labor", subcontractor: zh ? "分包" : "Subcontractor",
  permit: zh ? "许可费 / 市政费" : "Permit & City Fees", equipment: zh ? "设备" : "Equipment",
  site_facilities: zh ? "间接·施工现场费用" : "Site Facilities", logistics: zh ? "间接·运输物流" : "Logistics",
  waste_disposal: zh ? "间接·废料处理" : "Waste Disposal", project_insurance: zh ? "间接·项目保险" : "Project Insurance",
  testing: zh ? "间接·检测与测试" : "Testing", bonds: zh ? "间接·项目保证金" : "Bonds",
  design_eng: zh ? "设计与工程" : "Design & Engineering", other: zh ? "其他" : "Other",
}[c] || c);

export const KIND_LABEL = (k, zh) => ({ cost: zh ? "项目成本" : "Project cost", op: zh ? "运营费用" : "Operating", intercompany: zh ? "关联公司往来" : "Intercompany", refund: zh ? "客户退款" : "Customer refund", void: zh ? "作废" : "Void" }[k] || k);

/** 分类值：成本类别 key | "op:<opCategory>" | "intercompany" → 显示文字 */
export const catLabel = (val, meta, zh) => {
  if (!val) return "—";
  if (val === "intercompany" || val === "refund") return KIND_LABEL(val, zh);
  if (val.startsWith("op:")) {
    const k = val.slice(3);
    const o = (meta?.opCategories || []).find((x) => x.key === k);
    return `${zh ? "运营" : "Op"} · ${o ? (zh ? o.zh : o.en) : k}`;
  }
  return `${zh ? "成本" : "Cost"} · ${COST_LABEL(val, zh)}`;
};

export const catOptions = (meta, zh) => [
  { group: zh ? "项目成本（账单）" : "Project cost (bills)", items: (meta?.costCategories || []).map((k) => ({ value: k, label: COST_LABEL(k, zh) })) },
  { group: zh ? "运营费用（非项目）" : "Operating expenses", items: (meta?.opCategories || []).map((o) => ({ value: `op:${o.key}`, label: zh ? o.zh : o.en })) },
];

export const rowCat = (r) => (r.kind === "intercompany" || r.kind === "refund" ? r.kind : r.kind === "op" ? `op:${r.opCategory || "unclassified"}` : r.category || "other");

export const money0 = (n) => "$" + Math.round(Number(n || 0)).toLocaleString();
